module.exports = __webpack_public_path__ + "static/media/contentIntroduction3.c6901f57.png";